import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { CopyService } from 'src/app/shared/services/copies/copy.service';
import { HeaderService } from 'src/app/shared/services/header/header.service';
import { NavigationService } from 'src/app/shared/services/navigation/navigation-onboarding.service';
import { AbreCuentasService } from 'src/app/shared/services/abre-cuentas/abre-cuentas.service';
import { BitacoraService } from 'src/app/shared/services/bitacora/bitacora.service';
import { DisbursementModel } from 'src/app/shared/models/disbursement.model';
import { BUSINESS_CONST } from 'src/app/shared/constants/business.constants';
import { navCode } from 'src/app/shared/constants/channel.constants';
import { EVENT } from 'src/app/shared/constants/dali.constants';
import { Changes, TagEvent } from 'src/app/shared/models/dali-tags.model';
import { TaggingService } from 'src/app/shared/services/tagging/tagging.service';

@Component({
  selector: 'app-metodo-desembolso',
  templateUrl: './metodo-desembolso.component.html',
  styleUrls: ['./metodo-desembolso.component.scss'],
})
export class MetodoDesembolsoComponent implements OnInit {

  selectedoption: any;
  body: any = [];
  disbursement: any = [];
  haveTwoMethod = false;
  method: any;
  radioChecked = false;
  formGroup: FormGroup;
  continueFlag = false;
  flag = true;
  flag1 = false;
  flag2 = false;
  flag3 = false;
  flag4 = false;
  flag5 = false;
  flag6 = false;
  tag1: any;
  value: any;
  showOptions: boolean;
  checkboxList: any;
  checkboxListMult: any;
  checkboxListLoan: any;
  checkboxListPurchase: any;
  productsMulti: any;
  productType: any;
  amount: any = 0;
  constructor(
    public copyService: CopyService,
    private navigationService: NavigationService,
    private bitacora: BitacoraService,
    private headerService: HeaderService,
    private formBuilder: FormBuilder,
    private abreCuentasService: AbreCuentasService,
    private taggingService: TaggingService,
  ) {
    this.headerService.show(true, false, true);
    this.formGroup = this.formBuilder.group({});
    this.showOptions = false;
    this.checkboxListMult = [
      // Se realiza el retiro de los demas metodos de desembolso hasta que se certifique la fase 1
      // {
      //   id: 'checkbox1',
      //   label: copyService.copies.metodo_desembolso_option1,
      //   value: '1',
      //   checked: false,
      //   tag: 'cheque',
      // },
      {
        id: 'checkbox2',
        label: copyService.copies.metodo_desembolso_option2,
        value: '2',
        checked: false,
        tag: 'itau',
      },
      // {
      //    id: 'checkbox3',
      //    label: copyService.copies.metodo_desembolso_option3,
      //    value: '3',
      //    checked: false,
      //    tag: 'otro_banco',
      //  },
      // {
      //   id: 'checkbox4',
      //   label: copyService.copies.metodo_desembolso_option4,
      //   value: '4',
      //   checked: false,
      //   tag: 'cheque_otro_banco',
      // },
      // {
      //   id: 'checkbox5',
      //   label: copyService.copies.metodo_desembolso_option5,
      //   value: '5',
      //   checked: false,
      //   tag: 'cheque_itau',
      // },
    ];

    this.checkboxListLoan = [
      {
        id: 'checkbox1',
        label: copyService.copies.metodo_desembolso_option1,
        value: '1',
        checked: false,
        tag: 'cheque',
      },
      {
        id: 'checkbox2',
        label: copyService.copies.metodo_desembolso_option2,
        value: '2',
        checked: false,
        tag: 'itau',
      },
      {
        id: 'checkbox3',
        label: copyService.copies.metodo_desembolso_option3,
        value: '3',
        checked: false,
        tag: 'otro_banco',
      },
    ];

    this.checkboxListPurchase = [
      {
        id: 'checkbox1',
        label: copyService.copies.metodo_desembolso_option1,
        value: '1',
        checked: false,
        tag: 'cheque',
      },
    ];

    this.checkboxList = this.abreCuentasService.haveLoan ? this.checkListloan() : this.checkboxListMult;
  }

  checkListloan() {
    return this.abreCuentasService.getRequestLoanSelected().elementId === '01' || this.abreCuentasService.getRequestEntity() === 1
      ? this.checkboxListLoan
      : this.checkboxListPurchase;
  }

  selectOutlay() {
    console.log(this.selectedoption);

    if (this.selectedoption == 1) {
      this.radioChecked = true;
      this.flag1 = true;
    } else {
      this.flag1 = false;
    }
    if (this.selectedoption == 2) {
      this.radioChecked = true;
    }
    if (this.selectedoption == 3) {
      this.radioChecked = true;
      this.flag3 = true;
    } else {
      this.flag3 = false;
    }
    if (this.selectedoption == 4) {
      this.radioChecked = false;
      this.flag4 = true;
    } else {
      this.flag4 = false;
    }
    if (this.selectedoption == 5) {
      this.radioChecked = false;
      this.flag5 = true;
    } else {
      this.flag5 = false;
    }
  }

  radioButtonChange(event: any) {
    const radio = this.checkboxList.find(e => e.value === event.value);
    this.flag6 = true;
    if (!radio) { return; }
    this.selectedoption = radio.value;
    this.tag1 = radio.tag;
    this.selectOutlay();
  }

  /**
   * Summary initial event, customer information
   */
  ngOnInit() {
    this.sendTagging('init');
    this.abreCuentasService.setOfficeStatus(false);
    this.formGroup = new FormGroup({
      monto: new FormControl('', [Validators.required]),
    });
    // this.flag = this.abreCuentasService.isGrayZone() && this.abreCuentasService.haveLoan ? false : true;
    this.validChecked();
  }

  previous() {
    this.sendTagging('prev', 'bottom', '1');
  }

  next() {
    this.sendTagging('next', 'bottom', '2');
    this.bitacora.saveDataInBitacora('disbursement_method_' + this.tag1);
    this.abreCuentasService.setOutlaySelection(this.tag1);
    switch (this.tag1) {
      case 'cheque':
        this.abreCuentasService.setStatusCreate(false);
        this.generateDisburmentMethod(BUSINESS_CONST.CH);
        this.abreCuentasService.setOfficeStatus(true);
        if (this.abreCuentasService.haveLoan) {
          this.navigationService.nextStep(navCode[204]);
        } else {
          this.navigationService.nextStep(navCode[200]);
        }
        break;
      case 'itau':
        this.abreCuentasService.setStatusCreate(true);
        this.generateDisburmentMethod(BUSINESS_CONST.AC);
        this.bitacora.saveDataInBitacora('disbursement_method_' + this.tag1 + '_generateDisburmentMethod');
        if (this.abreCuentasService.getClientProduct()) {
          this.bitacora.saveDataInBitacora('disbursement_method_' + this.tag1 + '_navCode203');
          this.navigationService.nextStep(navCode[203]);
          return;
        }
        this.bitacora.saveDataInBitacora('disbursement_method_' + this.tag1 + '_navCode201');
        this.navigationService.nextStep(navCode[201]);
        break;
      case 'otro_banco':
        this.abreCuentasService.setStatusCreate(false);
        this.generateDisburmentMethod(BUSINESS_CONST.ACH);
        this.navigationService.nextStep(navCode[202]);
        break;
      case 'cheque_otro_banco':
        this.haveTwoMethod = true;
        this.abreCuentasService.setStatusCreate(false);
        this.generateDisburmentMethod(BUSINESS_CONST.CH);
        this.generateDisburmentMethod(BUSINESS_CONST.ACH);
        this.abreCuentasService.setOfficeStatus(true);
        this.navigationService.nextStep(navCode[200]);
        break;
      case 'cheque_itau':
        this.haveTwoMethod = true;
        this.abreCuentasService.setStatusCreate(true);
        this.generateDisburmentMethod(BUSINESS_CONST.CH);
        this.generateDisburmentMethod(BUSINESS_CONST.AC);
        this.abreCuentasService.setOfficeStatus(true);
        this.navigationService.nextStep(navCode[200]);
        break;
      default:
        break;
    }
  }

  disbursementInfo() {
    let disbursement: DisbursementModel = {
      product_type: '',
      refund: [],
    };

    if (this.disbursement.length > 0) {
      this.disbursement.forEach(prod => {
        if (prod.product_type === this.productType) {
          if (this.haveTwoMethod && (prod.product_type === BUSINESS_CONST.PRODUCT_TYPE_TC || prod.product_type === BUSINESS_CONST.PRODUCT_TYPE_REVOLVING)) {
            disbursement.product_type = '';
          } else {
            prod.refund.push(this.disbursementObject(this.method));
          }
        }
      });

      if (this.disbursement.filter(prod => prod.product_type === this.productType).length === 0) {
        disbursement.product_type = this.productType;
        disbursement.refund.push(this.disbursementObject(this.method));
      }
    } else {
      disbursement.product_type = this.productType;
      disbursement.refund.push(this.disbursementObject(this.method));
    }

    if (disbursement.product_type !== '') {
      this.disbursement.push(disbursement);
      this.abreCuentasService.setDisbursementInfo(this.disbursement);
    }

  }

  validLengthBranchId(branchId: string, length: number) {
    return branchId.padStart(length, '0');
  }

  getOfficeId() {
    let branchId;
    switch (this.abreCuentasService.getPostlogin()) {
      case true:
        branchId = this.validLengthBranchId(this.abreCuentasService.getCustomerData().basic.originator_branch, 3);
        break;
      default:
        if (this.abreCuentasService.getOutlaySelection() === BUSINESS_CONST.ITAU) {
          branchId = this.abreCuentasService.getAgencySelected()
            && this.abreCuentasService.getOutlaySelection() !== 'otro_banco' ?
            this.abreCuentasService.getAgencySelected().agency_code : '';
        } else if (this.abreCuentasService.haveLoan) {
          branchId = this.getOfficeByProduct();
        }
        break;
    }
    return branchId;
  }

  getOfficeByProduct() {
    let branchId;
    if (this.productType === BUSINESS_CONST.PRODUCT_TYPE_REVOLVING) {
      branchId = this.abreCuentasService.getAgencySelected() ? this.abreCuentasService.getAgencySelected().agency_code : '';
    } else {
      branchId = this.abreCuentasService.getDisbursementAgencySelected()
        && this.abreCuentasService.getOutlaySelection() !== 'otro_banco' ?
        this.abreCuentasService.getDisbursementAgencySelected().agency_code : '';
    }
    return branchId;
  }

  disbursementObject(method) {
    let disbursement = {
      refund_method: '',
      account: {},
      amount: {},
      bank_id: '',
      branch_id: this.getOfficeId(),
    };

    if (this.productType === BUSINESS_CONST.PRODUCT_TYPE_FREE || this.productType === BUSINESS_CONST.PRODUCT_TYPE_LOAN) {
      disbursement.refund_method = method;
    } else {
      disbursement.refund_method = '';
    }

    disbursement.account = {
      account_id: '',
      account_type: '',
      account_subtype: this.abreCuentasService.getStatusCreate() ? this.copyService.copies.create_account : '',
    };

    disbursement.amount = {
      currency: 'COP',
      amount: this.amount,
      decimals: 0,
    };
    this.amount = 0;
    return disbursement;
  }

  generateDisburmentMethod(method) {
    this.method = method;
    this.productsMulti = this.abreCuentasService.getProductsSelects();
    this.productsMulti.forEach(prod => {
      this.productType = prod.product_type;
      this.amount = this.abreCuentasService.haveLoan ?
        this.abreCuentasService.getAbreCuentasModel().creditParms.maxAmountValue
        : this.abreCuentasService.getAmout(prod.product_type);
      if ((this.productType === BUSINESS_CONST.PRODUCT_TYPE_FREE || this.productType === BUSINESS_CONST.PRODUCT_TYPE_LOAN) &&
        !this.abreCuentasService.isGrayZone() &&
        Number(this.amount) > Number(this.formGroup.value.monto)) {
        if (this.haveTwoMethod && this.method === BUSINESS_CONST.CH) {
          this.totalChAmount();
        } else if (this.haveTwoMethod && (this.method === BUSINESS_CONST.ACH || this.method === BUSINESS_CONST.AC)) {
          this.totalAmount_CH_TR();
        }
      }
      this.disbursementInfo();
    });
  }

  /** Funcion que retorna el monto por el cual debe realizarse la transferencia  */
  totalAmount_CH_TR() {
    let amountCH = this.formGroup.value.monto;
    this.amount = Number(this.amount) - Number(amountCH);
  }

  /** Funcion que retorna el monto por el cual debe generarse el cheque */
  totalChAmount() {
    if (this.formGroup.valid) {
      this.amount = this.formGroup.value.monto;
    }
  }

  validChecked() {
    if (this.abreCuentasService.getOutlaySelection()) {
      this.checkboxList.forEach(outlay => {
        if (outlay.tag === this.abreCuentasService.getOutlaySelection()) {
          outlay.checked = true;
          this.radioButtonChange(outlay);
        }
      });
    }
  }
  sendTagging(value: any, position?: string, event?: string) {
    const page = '14';
    const extras = {
      pageValue: 'MetodoDesembolso',
    };
    this.taggingService.sendTaggValues(value, page, position, event, extras);
  }
}
